import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { toApiError } from '../utils';
import type { CultureDTO } from './useGetCultures';

export interface CreateCulturePayload {
	name: string;
}

export const useCreateCulture = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (payload: CreateCulturePayload) => {
			try {
				const { data } = await api.post<CultureDTO>('/cultures/create', payload);
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao criar cultura');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['cultures'] });
		},
	});
};
